'use strict';
const _ = require('lodash');
const Backbone = require('backbone');
const PubSub = require('../PubSub');
const template = require('../templates/global-banner.ejs');

module.exports = Backbone.View.extend({
    className: 'global-banner-container',
    events: {
        'click .banner' : 'openUpsell'
    },
    /**
     *
     */
    initialize: function (options) {
        _.bindAll(this, 'render');
        
        options = options || {};
        this.model = options.model;
    },
    /**
     *
     */
    render: function () {

        this.$el.html(template(this.model));
        return this;
    },

    openUpsell: function() {
        PubSub.trigger('openUpsell')
    }
});



// WEBPACK FOOTER //
// ./app/scripts/views/global-banner.js